module.exports = __webpack_public_path__ + "0a0a60a2512cea28554bd1666b4b989a.mp4";